import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SlidePanel from "./SlidePanel";
import { BadgeIcons } from "./Badges";

function Avatar({ account }) {
  const [broken, setBroken] = useState(false);
  const initial = (account.name || account.username || "?").trim()[0].toUpperCase();
  if (account.avatar && !broken) {
    return <img className="profile-avatar" src={account.avatar} alt="" onError={() => setBroken(true)} />;
  }
  return <div className="profile-avatar profile-avatar-fallback">{initial}</div>;
}

export default function ProfileCard({
  API_BASE, account, favoriteCount, onClose,
  onOpenFavorites, onOpenLeaderboard, onOpenPublicProfile, onOpenSubmissions, onOpenSettings, onOpenPrivacy, onLogout,onOpenTerms
}) {
  const [subs, setSubs] = useState(null);
  const [me, setMe] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/my_submissions`, { headers: { Authorization: `Bearer ${Cookies.get("session")}` } })
      .then((r) => r.json())
      .then((d) => Array.isArray(d) && setSubs(d))
      .catch(() => {});
    fetch(`${API_BASE}/api/leaderboard`, { headers: { Authorization: `Bearer ${Cookies.get("session")}` } })
      .then((r) => r.json())
      .then((d) => d.me && setMe(d.me))
      .catch(() => {});
  }, [API_BASE]);

  const approved = subs ? subs.filter((s) => s.status === "approved").length : "–";
  const pending = subs ? subs.filter((s) => s.status === "pending").length : "–";

  return (
    <SlidePanel title="Profile" onClose={onClose}>
      <div className="profile-hero">
        <Avatar account={account} />
        <h3>{account.name || account.username}</h3>
        <p className="profile-handle">@{account.username}{account.admin && <span className="admin-pill">Admin</span>}</p>
        {account.bio && <p className="profile-bio">{account.bio}</p>}
      </div>

      <div className="profile-stat-grid">
        <button onClick={onOpenLeaderboard}><strong>{me ? me.points : "–"}</strong><span>Points</span></button>
        <button onClick={onOpenFavorites}><strong>{favoriteCount}</strong><span>Favorites</span></button>
        <button onClick={onOpenSubmissions}><strong>{approved}</strong><span>Approved</span></button>
        <button onClick={onOpenSubmissions}><strong>{pending}</strong><span>Pending</span></button>
      </div>

      {me?.badges?.length > 0 && (
        <button type="button" className="profile-badges" onClick={onOpenPublicProfile} title="See all your badges">
          <BadgeIcons ids={me.badges} max={8} /> <span>{me.badges.length} badge{me.badges.length === 1 ? "" : "s"}</span>
        </button>
      )}

      <dl className="profile-details">
        {account.email && (<><dt>Email</dt><dd>{account.email}</dd></>)}
        {account.country && (<><dt>Country</dt><dd>{account.country}</dd></>)}
      </dl>
      <p className="panel-hint">Your public profile shows your username, bio, points and approved work. Your email and country are private — they're never shown on the map.</p>

      <div className="panel-stack">
        <button className="panel-secondary" onClick={onOpenPublicProfile}>🌐 Public profile &amp; edit bio</button>
        <button className="panel-secondary" onClick={onOpenSettings}>⚙ Account settings</button>
        <button className="panel-secondary" onClick={onOpenPrivacy}>🔒 Privacy policy</button>
        <button className="panel-secondary" onClick={onOpenTerms}>🤝 Terms and Conditions</button>
        <button className="panel-secondary danger" onClick={onLogout}>Sign out</button>
      </div>
    </SlidePanel>
  );
}
